import type { PageFooterSectionName } from './types/PageFooterData';

export const pageFooterOrderedSectionsMetadata: {
  sectionName: PageFooterSectionName;
}[] = [
  { sectionName: 'idealistDays' },
  { sectionName: 'findAJob' },
  { sectionName: 'postOnIdealist' },
  { sectionName: 'aboutUsNew' },
  { sectionName: 'contactUs' },
];
